"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.forgotThunk = exports.registrationThunk = exports.logoutThunk = exports.loginThunk = exports.getMeThunk = void 0;
const actions_1 = require("src/stores/exportedStore/loader/actions");
const axios_1 = __importDefault(require("src/utils/axios"));
const actions_2 = require("./actions");
const useLocalStorage_1 = require("src/hooks/useLocalStorage");
const sharedUtils_1 = require("src/utils/sharedUtils");
const getMeThunk = (adminLocation = false) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch((0, actions_1.setLoading)(true));
    try {
        const res = yield axios_1.default.get("/api/v1/users/profile/me/");
        if (res.status == 200) {
            if (adminLocation && !res.data.admin_role) {
                window.location.replace("/");
            }
            dispatch((0, actions_2.setUser)(res.data));
        }
    }
    catch (error) {
        console.error;
    }
    finally {
        dispatch((0, actions_1.setLoading)(false));
    }
});
exports.getMeThunk = getMeThunk;
const loginThunk = (data, setErrors) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch((0, actions_1.setLoading)(true));
    try {
        const res = yield axios_1.default.post("/api/v1/users/account/login/", data);
        if (res.status == 200) {
            window.location.href = "/";
            dispatch((0, exports.getMeThunk)());
        }
    }
    catch (error) {
        console.log(error);
        setErrors(error.response.data);
    }
    finally {
        dispatch((0, actions_1.setLoading)(false));
    }
});
exports.loginThunk = loginThunk;
const logoutThunk = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch((0, actions_1.setLoading)(true));
    try {
        const res = yield axios_1.default.get("/api/v1/users/account/logout/");
        if (res.status == 200) {
            window.location.href = "/";
        }
    }
    catch (error) {
        console.error;
    }
    finally {
        dispatch((0, actions_1.setLoading)(false));
    }
});
exports.logoutThunk = logoutThunk;
const registrationThunk = (data, setErrors) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch((0, actions_1.setLoading)(true));
    try {
        const utms = JSON.parse((0, useLocalStorage_1.getLocalStorageItem)("utm")) || {};
        const res = yield axios_1.default.post("/api/v1/users/account/register/", Object.assign(Object.assign({}, data), utms));
        if (res.status === 201) {
            if (!(0, sharedUtils_1.isDev)()) {
                ym(92974833, "reachGoal", "SIGNUP_END");
            }
            (0, useLocalStorage_1.removeLocalStorageItem)("utm");
            window.location.href = "/settings/setup";
        }
    }
    catch (error) {
        console.log(error);
        setErrors(error.response.data);
    }
    finally {
        dispatch((0, actions_1.setLoading)(false));
    }
});
exports.registrationThunk = registrationThunk;
const forgotThunk = (data, setErrors, setSuccess) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch((0, actions_1.setLoading)(true));
    try {
        const res = yield axios_1.default.post("/api/v1/users/account/password_forgot/", data);
        if (res.status === 200) {
            setSuccess(true);
        }
    }
    catch (error) {
        console.log(error);
        setErrors(error.response.data);
    }
    finally {
        dispatch((0, actions_1.setLoading)(false));
    }
});
exports.forgotThunk = forgotThunk;
